export const isGiftingHomePage = (path) => path.includes('/redeem');

export const isGiftingPages = (path) => path.includes('redeem');

export const isSignUpPage = (path) => path.includes('signup-account');

export const isSignUpPlans = (path) => path.includes('signup-plans');

//Necessary to prevent XSS attacks, e.g. with javascript:eval( starting url
//See NATCOM-1285
// if url contains protocol, only escape the rest of the url and attach the protocol again after escaping
// escape specific characters because encodeURIComponent breaks the url as it escapes forward slashes and
//    encodeURI does not escape colons (which do not prevent javascript injection e.g. the above example)
export const sanitizePath = (path) => {
  const pathIsNotSecure = /^http\:/.test(path);
  if (pathIsNotSecure) return false;

  const specialCharacters = /[<>"':;()+%]/g;

  const pathContainsProtocol = /^https\:/.test(path);
  if (pathContainsProtocol) {
    const splitPath = path.split(':');
    return (
      splitPath[0] +
      ':' +
      splitPath
        .slice(1)
        .join(':')
        .replace(specialCharacters, (charToEscape) => {
          return '%' + charToEscape.charCodeAt(0).toString(16);
        })
    );
  }
  return path.replace(specialCharacters, (charToEscape) => {
    return '%' + charToEscape.charCodeAt(0).toString(16);
  });
};

export const setLocation = (path, type = 'replace') => {
  const sanitizedPath = sanitizePath(path);
  if (sanitizedPath === false) {
    //This is not a real path - just is a path to take user to NotFoundContainer.js
    return window.location.replace('/account/notfound');
  }

  switch (type) {
    case 'replace':
      window.location.replace(sanitizedPath);
      break;
    case 'assign':
      window.location.assign(sanitizedPath);
      break;
    case 'href':
      window.location.href = sanitizedPath;
      break;
  }
};
